import axios, { axiosPrivate } from "./axios";

class PreviewCertificateAPI {
  /**
   * Upload CSV file
   * @param {File} file
   * @param {string} templateId
   * @returns
   */
  static async csvUpload({ file, collectionId }) {
    const response = await axiosPrivate.post(
      `/certificates/collections/upload/${collectionId}`,
      {
        file
      },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  }

  /**
   * Send selected certificates
   * @param {string} templateId
   * @param {string[]} certificateIds
   * @returns
   */
  static async sendSelectedCertificate({ templateId, certificateIds }) {
    const response = await axiosPrivate.post(
      `/certificates/templates/${templateId}/send`,
      {
        certificateIds
      }
    );

    return response.data;
  }

  /**
   * Send selected certificates
   * @param {string} templateId
   * @returns
   */
  static async sendAllNotSentCertificate(templateId) {
    const response = await axiosPrivate.get(
      `/certificates/templates/${templateId}`
    );

    return response.data;
  }

  /**
   * Download all certificates
   * @param {string} templateId
   * @param {string} collectionId
   * @returns
   */
  static async downloadAllCertificate(templateId, collectionId) {
    const response = await axiosPrivate.post(
      `/certificates/${collectionId}/${templateId}/download`,
      {
        format: "pdf"
      },
      {
        responseType: "blob",
        params: { all: true }
      }
    );

    return response.data;
  }

  /**
   * Download sent certificates
   * @param {string} collectionId
   * @returns
   */
  static async downloadAllSentCertificate(collectionId) {
    const response = await axiosPrivate.get(
      `/certificates/download/${collectionId}`,
      {
        responseType: "blob"
      }
    );

    return response.data;
  }

  /**
   * Send a single certificate
   * @param {string} templateId
   * @param {string} certificateId
   * @returns
   */
  static async sendSingleCertificate({ templateId, certificateId }) {
    console.log(certificateId);
    const response = await axiosPrivate.post(
      `/certificates/templates/${templateId}/send`,
      {
        certificateIds: [certificateId]
      }
    );

    return response.data;
  }

  /**
   * Download a single certificate
   * @param {string} certificateId
   * @returns
   */
  static async downloadSingleCertificate(certificateId) {
    const response = await axiosPrivate.post(
      `/certificates/${certificateId}/download`,
      {
        format: "pdf"
      },
      {
        responseType: "blob"
      }
    );

    return response.data;
  }

  /**
   * Create a certificate
   * @param {string} collectionId
   * @param {{email: string, password: string}} data
   * @returns
   */
  static async createTableCertificate(collectionId, data) {
    const response = await axiosPrivate.post(
      `/certificates/collections/${collectionId}`,
      data
    );

    return response.data;
  }

  /**
   * Delete selected certificates
   * @param {string} collectionId
   * @param {string[]} certificateIds
   * @returns
   */
  static async deleteSelectedCertificate(collectionId, certificateIds) {
    const response = await axiosPrivate.delete(
      `/certificates/collections/${collectionId}`,
      {
        data: {
          certificateIds
        }
      }
    );

    return response.data;
  }

  static async getCertificateCollection(collectionId, pageNumber, searchParam) {
    const response = await axiosPrivate.get(
      `/certificates/collections/${collectionId}?page=${pageNumber}&search=${searchParam}`
    );
    return response.data.data;
  }

  static async unauthPreviewCertificate(id) {
    const response = await axios.get(`/certificates/verify/${id}`);
    return response.data.data;
  }

  static async authPreviewCertificate(id) {
    const response = await axiosPrivate.get(`/certificates/verify/${id}`);
    return response.data.data;
  }
}

export default PreviewCertificateAPI;
